import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Shared";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

function ChangeDetails({ log }) {
  if (log.action !== "update_anagrafica" || !log.after) return "—";
  return (
    <div className="space-y-0.5" data-testid={`audit-details-${log.id}`}>
      {Object.keys(log.after).map((k) => (
        <div key={k}><span className="font-semibold">{FIELD_LABELS[k] || k}:</span> <span className="line-through text-rose-600">{log.before?.[k] || "(vuoto)"}</span> → <span className="text-emerald-700">{log.after[k] || "(vuoto)"}</span></div>
      ))}
    </div>
  );
}

const FIELD_LABELS = { first_name: "Nome", last_name: "Cognome", fiscal_code: "Codice Fiscale", email: "E-mail" };

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Registro delle attività amministrative e delle modifiche." />
      <Card className="border-slate-200 overflow-hidden">
        <Table>
          <TableHeader className="bg-slate-50"><TableRow>
            <TableHead>Data/Ora</TableHead><TableHead>Utente</TableHead><TableHead>Azione</TableHead>
            <TableHead>Entità</TableHead><TableHead>Dettagli modifica</TableHead><TableHead>Motivazione</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                <TableCell className="text-xs text-slate-500 font-mono">{new Date(l.at).toLocaleString("it-IT")}</TableCell>
                <TableCell className="text-sm">{l.user_email || "sistema"}</TableCell>
                <TableCell className="text-sm font-medium">{l.action}</TableCell>
                <TableCell className="text-sm text-slate-500">{l.entity}</TableCell>
                <TableCell className="text-xs text-slate-600"><ChangeDetails log={l} /></TableCell>
                <TableCell className="text-sm text-slate-500">{l.reason || "—"}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-400 py-8">Nessuna attività.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
